import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import { WISHLIST_KEY } from "../constants/query.constants";
import { addUserWishList, getUserWishLists, removeUserWishList } from "../repositories/wishlist/wishlistReposotory";
import toast from "react-hot-toast";
import authService from "../services/authService";

export const useGetWishLists = () => {
  return useQuery({
    queryKey: [WISHLIST_KEY],
    queryFn: getUserWishLists,
    enabled: !!authService.getCurrentUser(),
    initialData: [],
    staleTime: 0,
    cacheTime: 0,
  });
};

export const useAddToWishList = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => addUserWishList(payload),

    onMutate: async (payload) => {
      await queryClient.cancelQueries([WISHLIST_KEY]);

      const previousData = queryClient.getQueryData([WISHLIST_KEY]);

      const exists = previousData?.some(
        (item) => item?.product_id === payload.product_id
      );

      if (exists) {
        toast.dismiss("wishlist");
        toast.error("Already in wishlist");
        throw new Error("Item already in wishlist");
      }

      const newItem = {
        id: Date.now(),
        product_id: payload.product_id,
        _optimistic: true,
      };

      queryClient.setQueryData([WISHLIST_KEY], (old = []) => [
        ...old,
        newItem,
      ]);

      return { previousData };
    },

    onSuccess: () => {
      toast.success("Added to Wishlist ❤️", { id: "wishlist" });
      queryClient.invalidateQueries([WISHLIST_KEY]);
    },

    onError: (error, _, context) => {
      toast.dismiss("wishlist"); 
      toast.error(error?.message || "Failed to add to wishlist");
      queryClient.setQueryData([WISHLIST_KEY], context?.previousData || []);
    },
  });
};


export const useRemoveWishList = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: removeUserWishList,

    onMutate: async (id) => {
      await queryClient.cancelQueries([WISHLIST_KEY]);

      const previous = queryClient.getQueryData([WISHLIST_KEY]);

      queryClient.setQueryData([WISHLIST_KEY], (old) =>
        old.filter((i) => i.id !== id)
      );

      return { previous };
    },

    onError: (err, id, context) => {
      queryClient.setQueryData([WISHLIST_KEY], context.previous);
      toast.error("Failed to remove");
    },
    onSettled: () => {
      queryClient.invalidateQueries([WISHLIST_KEY]);
    },
  });
};
